import { Col, Row, Card, Table } from 'antd';
import React from 'react';
import { driverRates, getColumnsWithHighlight } from '../AllOrgActivities/helper';
import { renderRegularRateEntry } from '../AllOrgActivities/formHelper';

export const AccDriverRates = ({ data }) => {

    const renderRegularGroup = (changes, title, action) => {
      if(action === "UPDATE") return null;
    const keyName = changes?.new_value ? 'new_value' : changes?.old_value ? 'old_value' : null;
        return (
          <div className="mb-6">
            <h4
              className="ant-typography ant-typography-md font-medium mb-3"
              style={{ textAlign: "left", fontSize: "16px" }}
            >
              {title}
            </h4>
            <Card
             style={{
              background: "#fff",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.09)",
              marginBottom: "16px",
              padding: "2px",
            }}
            >
              {renderRegularRateEntry(changes, title, "ADDED")}
              <Table
                columns={driverRates}
                dataSource={changes[keyName]?.driver_rate_params || []}
                pagination={false}
                bordered
                scroll={{ x: 'max-content', y:`calc(100vh - 600px)` }}
              />
            </Card>
          </div>
        );
    };

    const renderModifiedGroup = (changes) => {

        const oldValues = changes?.old_value?.driver_rate_params
        const newValues = changes?.new_value?.driver_rate_params
        if (!oldValues || !newValues) return null;
        const newColumns = getColumnsWithHighlight(driverRates, oldValues, newValues);

        return (
            <div className="mb-6">
                <h4 className="ant-typography ant-typography-md font-medium mb-3" style={{ textAlign: 'left', fontSize: '16px' }}>Modified Entries</h4>
                <h5 className="ant-typography ant-typography-sm font-medium mb-2" style={{ textAlign: 'left', color: '#666', fontWeight: 'bold' }}>Previous Values</h5>
                <div className="mb-4">
                    <Card
                     style={{
                      background: "#fff",
                      borderRadius: "8px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.09)",
                      marginBottom: "16px",
                      padding: "2px",
                    }}
                    >
                      {renderRegularRateEntry(changes, 'Previous Values', 'previous')}
                        <Table
                            columns={driverRates}
                            dataSource={oldValues}
                            pagination={false}
                            bordered
                            scroll={{ x: 'max-content', y:`calc(100vh - 600px)` }}
                        />
                    </Card>
                </div>
                <h5 className="ant-typography ant-typography-sm font-medium mb-2" style={{ textAlign: 'left', color: '#666', fontWeight: 'bold' }}>Updated Values</h5>
                <div>
                    <Card
                     style={{
                      background: "#fff",
                      borderRadius: "8px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.09)",
                      marginBottom: "16px",
                      padding: "2px",
                    }}
                    >
                      {renderRegularRateEntry(changes, 'Updated Values', 'new')}
                        <Table
                            columns={newColumns}
                            dataSource={newValues}
                            pagination={false}
                            bordered
                            scroll={{ x: 'max-content', y:`calc(100vh - 600px)` }}
                        />
                    </Card>
                </div>
            </div>
        );
    };

    const driverRatesData = data?.difference[0] ? data?.difference[0] : [];
    const incomingEntry = driverRatesData?.new_value ? "New Entry" : "Old Entry";
    const incomingAction = data?.action

    const renderFuelSurchargeMain = () => {
        return (
            <div className="mt-6">
                <h4 className="ant-typography ant-typography-md font-medium mb-3" style={{ textAlign: 'left', fontSize: '18px' }}>
                    <span style={{ fontSize: '20px', color: '#395484' }}>Driver Rates</span>
                    <div className="mt-6">
                        {renderRegularGroup(driverRatesData, incomingEntry,incomingAction)}
                        {renderModifiedGroup(driverRatesData)}
                    </div>
                </h4>
            </div>
        );
    };

  return (
    <Row gutter={[16, 32]}>
        <Col span={24}>{renderFuelSurchargeMain()}</Col>
    </Row>
  );
};